import api from '@/services/base.service'

const methods = {
  getUsuariosByBodega(bodega) {
    return api.get(`/bodegas/${bodega}/usuarios`)
  },
  getBodegasBySucursal(sucursal) {
    return api.get(`/sucursales/${sucursal}/bodegas`)
  },
  getBodegas(sucursalId) {
    return api.get(`/bodegas`, { params: { sucursalId } })
  },
  getBodega(id) {
    return api.get(`/bodegas/${id}`)
  },
  addBodega(bodega) {
    return api.post(`/bodegas`, bodega)
  },
  updateBodega(id, bodega) {
    return api.put(`/bodegas/${id}`, bodega)
  },
  deleteBodega(id) {
    return api.delete(`/bodegas/${id}`)
  }
}

export default methods
